import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;



class Invoice {
  create = async (invoice: any) => {
    const res = await axios.post(`${API_URL}invoice`, invoice)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data;
  };

  edit = async (invoice: any, code: any) => {
    const res = await axios.put(`${API_URL}invoice/${code}`, invoice)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data;
  };

  getPrevInvoice = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}invoice/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.invoice;
  };

  get = async (code: any) => {
    const response = await axios.get(`${API_URL}invoice/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data;
  };

  showForReversal = async (code: any) => {
    const response = await axios.get(`${API_URL}invoice-show-for-reversal/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data;
  };


  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}invoice`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.invoice;
  };

  getLastThree = async (key: any) => {
    const response = await axios.get<any>(`${API_URL}recent-invoice/${key ? key : 0}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.invoice;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}invoice-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.invoice;
  };

  customerOutstanding = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}invoice-outstanding-customer/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.invoices;
  };

  reversal = async (code: any) => {
    const response = await axios.put<any>(`${API_URL}invoice-reversal`, code)
      .catch((e) => {
        throw e.message;
      });
    return response.data.invoices;
  };

  periodicSearch = async (from: any, to: any) => {
    const response = await axios.get<any>(`${API_URL}sales-location-report`, {
      params: {
        fromDate: `${from} 00:00:00`,
        toDate: `${to} 23:59:59`,
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.salesReport;
  };
  sms = async (values:any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}send-sms`,
      data:values
      
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };
}

export default new Invoice();
